import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/")({
	component: Index,
	beforeLoad: async ({ context }) => {
		// Check if user is authenticated
		const session = context?.auth?.data;

		if (session?.user) {
			// User is authenticated, redirect to dashboard
			throw redirect({
				to: "/account",
			})
		} else {
			// User is not authenticated, redirect to login
			throw redirect({
				to: "/login",
			})
		}
	},
});

function Index() {
	// This component should rarely be rendered due to redirects
	return <div>Redirecting...</div>;
}

// return (
// 	<Navigate
// 		to={"/live/report/live/$liveId"}
// 		search={{
// 			name: data?.name ?? "",
// 		}}
// 		params={{
// 			liveId: data?.liveId ?? "",
// 		}}
// 	/>
// );
